import { AxiosInstance } from "axios";

interface AppConfig {
  fragments: {
    [microfrontendName: string]: {
      [property: string]: string | Array<string>;
    }
  }
}

class Configurator {
  public config: AppConfig = {} as AppConfig;

  public apiClient: AxiosInstance;

  constructor(apiClient: AxiosInstance) {
    this.apiClient = apiClient;
  }

  async getConfig(): Promise<void> {
    return this.apiClient
      .get("config.json")
      .then(({ data }: { data: AppConfig }) => {
        this.config = data;
      })
      .catch(() => Promise.resolve());
  }

  onError(e: Error): void {
    const formattedError = e?.message || JSON.stringify(e);

    console.error(e);
    alert(`The app cannot be started because of error ${formattedError}`);
  }
}

export default Configurator;
